import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import SuperAdminDashboard from './pages/SuperAdminDashboard.tsx'
import ChillSetterDashboard from './pages/ChillSetterDashboard.tsx'
import AuthDebug from './pages/AuthDebug.tsx'
import { NotificationProvider } from './contexts/NotificationContext.tsx'
import './index.css'
import { registerServiceWorker } from './pwa'

registerServiceWorker()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <NotificationProvider>
      <Router basename="/">
        <Routes>
          {/* /admin was a second console with its own login and its own five
              tabs. Everything it had now lives in the sections below, so the
              path redirects rather than 404s: it is in bookmarks, and in three
              setup guides. */}
          <Route path="/admin" element={<Navigate to="/superadmin" replace />} />
          {/* Section and tab live in the path, so a view can be bookmarked,
              shared, and survives a refresh. The bare /superadmin entry point
              is kept so existing links still work. */}
          <Route path="/superadmin" element={<SuperAdminDashboard />} />
          <Route path="/superadmin/:sectionKey" element={<SuperAdminDashboard />} />
          <Route path="/superadmin/:sectionKey/:tabKey" element={<SuperAdminDashboard />} />
          <Route path="/chill-setter" element={<ChillSetterDashboard />} />
          {/* Development only. This page reports auth state and was reachable
              on the production admin host, which is no use to anyone but
              someone probing it. Vite drops the branch from the prod bundle. */}
          {import.meta.env.DEV && <Route path="/debug" element={<AuthDebug />} />}
          <Route path="/" element={<Navigate to="/superadmin" replace />} />
        </Routes>
      </Router>
    </NotificationProvider>
  </React.StrictMode>,
) 